// This component renders a social media icon that links to a specified URL.
import React from "react";

const SocialIcon = ({ href, label, Icon }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="social-icon"
    aria-label={label}
    title={label}
  >
    <Icon />
  </a>
);

export default SocialIcon;
